import React, { useContext, useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { ShopContext } from "../context/ShopContext";
import { toast } from "react-toastify";
import { FaPlusCircle } from "react-icons/fa";
import { ShopContext } from '../context/ShopContext';
import axios from "axios";


const backendUrl = import.meta.env.VITE_BACKEND_URL; // Replace with your backend URL



const LogoutButton = () => {

  const {  setToken, setCartItems } = useContext(ShopContext);
  const navigate = useNavigate();
  
  // Handle the logout process
  const logout = () => {
    localStorage.removeItem('token');
    // Assuming you also have a state to manage the token
    setToken('');  
    // Clear cart items as well if you need
    setCartItems({});
    // Redirect to login page
    navigate('/login');
    toast.success("Logged out successfully!");
  };

  return (
    <button
    className="bg-[#FF4902] text-white px-4 py-2 rounded mt-4 "
    onClick={logout} // Logout logic added here
  >
    Logout
  </button>
  );
};

const Profile = () => {
    useEffect(() => {
          const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
          axios.post(`${backendUrl}/api/analytics/visit`, { page: "Profile" })
            .then(res => console.log(" visit recorded:", res.data))
            .catch(err => console.error("Analytics error:", err));
        }, []);
  const { userData } = useContext(ShopContext);
  const navigate = useNavigate();
  const [newCard, setNewCard] = useState({
    cardNumber: "",
    nameOnCard: "",
    expiryMonth: "",
    expiryYear: "",
    cvv: "",
  });

  const [newAddress, setNewAddress] = useState({
    street: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });

  const [showAddressForm, setShowAddressForm] = useState(false);

  const handleAddCard = () => {
    fetch(`${backendUrl}/api/user/profile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ card: newCard }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          toast.success("Card added successfully!");
        } else {
          toast.error("Failed to add card.");
        }
      })
      .catch((error) => console.error("Error adding card:", error));
  };

  if (!userData) {
    return <div className="text-center text-black mt-10">No user data found.</div>;
  }

  const handleAddAddress = () => {
    fetch(`${backendUrl}/api/user/profile`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ address: newAddress }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          toast.success("Address added successfully!");
        } else {
          toast.error("Failed to add address.");
        }
      })
      .catch((error) => console.error("Error adding address:", error));
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center p-6 mt-8 relative">
      {/* Navigation Toggle Buttons */}
      <div className="flex justify-center items-center mb-6">
        <button
          className={`px-6 py-2 rounded-l-sm ${
            window.location.pathname === "/profile" ? "bg-[#FF4902] text-white" : "bg-gray-300 text-black"
          }`}
          onClick={() => navigate("/profile")}
        >
          Profile
        </button>
        <button
          className={`px-6 py-2 rounded-r-sm ${
            window.location.pathname === "/orders" ? "bg-[#FF4902] text-white" : "bg-gray-300 text-black"
          }`}
          onClick={() => navigate("/orders")}
        >
          Orders
        </button>
      </div>

      {/* Welcome Message */}
      <div className="self-start text-3xl font-bold mb-6">Welcome, {userData.name}</div>

      {/* Personal Information */}
      <div className="flex flex-col md:flex-row gap-6 w-full max-w-5xl mt-11">
        <div className="flex-1 border-2 border-black p-6 rounded-lg">
          <h2 className="text-xl font-bold mb-6">Personal Information</h2>
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 border border-black rounded-lg p-4">
              <strong>Name:</strong> {userData.name}
            </div>
            <div className="flex-1 border border-black rounded-lg p-4">
              <strong>Email:</strong> {userData.email}
            </div>
            <div className="flex-1 border border-black rounded-lg p-4">
              <strong>Mobile Number:</strong> {userData.mobilenumber}
            </div>
          </div>
        </div>
      </div>

      {/* Address Section */}
      <div className="border-2 border-black p-6 rounded-lg mt-8 w-full max-w-5xl">
        <h2 className="text-xl font-bold mb-6">Address Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {userData.addresses?.length > 0 ? (
            userData.addresses.map((address, index) => (
              <div key={index} className="border-2 border-black p-4 rounded-lg">
                <div className="border border-black p-2 rounded">
                  <strong>Street:</strong> {address.street}
                </div>
                <div className="border border-black p-2 rounded">
                  <strong>City:</strong> {address.city}
                </div>
                <div className="border border-black p-2 rounded">
                  <strong>State:</strong> {address.state}
                </div>
                <div className="border border-black p-2 rounded">
                  <strong>Zip:</strong> {address.zip}
                </div>
                <div className="border border-black p-2 rounded">
                  <strong>Country:</strong> {address.country}
                </div>
              </div>
            ))
          ) : (
            <p>No addresses found.</p>
          )}

          {/* Add New Address Button */}
          <button
            className="flex items-center justify-center border-2 border-black p-4 rounded-lg"
            onClick={() => setShowAddressForm(!showAddressForm)}
          >
            <FaPlusCircle className="mr-2" /> Add New Address
          </button>

          {/* Add New Address Form */}
          {showAddressForm && (
            <div className="border-2 border-black p-4 rounded-lg mt-4">
              <h3 className="font-bold">Add New Address</h3>
              <input
                type="text"
                placeholder="Street"
                className="w-full border p-2 rounded mt-2"
                value={newAddress.street}
                onChange={(e) => setNewAddress({ ...newAddress, street: e.target.value })}
              />
              <input
                type="text"
                placeholder="City"
                className="w-full border p-2 rounded mt-2"
                value={newAddress.city}
                onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
              />
              <input
                type="text"
                placeholder="State"
                className="w-full border p-2 rounded mt-2"
                value={newAddress.state}
                onChange={(e) => setNewAddress({ ...newAddress, state: e.target.value })}
              />
              <input
                type="text"
                placeholder="Zip Code"
                className="w-full border p-2 rounded mt-2"
                value={newAddress.zip}
                onChange={(e) => setNewAddress({ ...newAddress, zip: e.target.value })}
              />
              <input
                type="text"
                placeholder="Country"
                className="w-full border p-2 rounded mt-2"
                value={newAddress.country}
                onChange={(e) => setNewAddress({ ...newAddress, country: e.target.value })}
              />
              <button className="bg-black text-white px-4 py-2 rounded mt-4" onClick={handleAddAddress}>
                Save Address
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Credit Cards Section */}
      <div className="border-2 border-black p-6 rounded-lg mt-8 w-full max-w-5xl">
        <h2 className="text-xl font-bold mb-6">Credit Cards</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {userData.creditCards?.length > 0 ? (
            userData.creditCards.map((card, index) => (
              <div key={index} className="border-2 border-black p-4 rounded-lg">
                <div className="border border-black p-2 rounded">
                  <strong>Card Number:</strong> **** **** **** {card.cardNumber.slice(-4)}
                </div>
                <div className="border border-black p-2 rounded">
                  <strong>Name on Card:</strong> {card.nameOnCard}
                </div>
                <div className="flex gap-2">
                  <div className="border border-black p-2 rounded w-1/2">
                    <strong>Expiry:</strong> {card.expiryMonth}/{card.expiryYear}
                  </div>
                  <div className="border border-black p-2 rounded w-1/2">
                    <strong>CVV:</strong> ***
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No credit cards found.</p>
          )}

          {/* Add New Card Form */}
          <div className="border-2 border-black p-4 rounded-lg mt-4">
            <h3 className="font-bold">Add New Card</h3>
            <input
              type="text"
              placeholder="Card Number"
              className="w-full border p-2 rounded mt-2"
              value={newCard.cardNumber}
              onChange={(e) => setNewCard({ ...newCard, cardNumber: e.target.value })}
            />
            <input
              type="text"
              placeholder="Name on Card"
              className="w-full border p-2 rounded mt-2"
              value={newCard.nameOnCard}
              onChange={(e) => setNewCard({ ...newCard, nameOnCard: e.target.value })}
            />
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Expiry Month"
                className="w-1/2 border p-2 rounded mt-2"
                value={newCard.expiryMonth}
                onChange={(e) => setNewCard({ ...newCard, expiryMonth: e.target.value })}
              />
              <input
                type="text"
                placeholder="Expiry Year"
                className="w-1/2 border p-2 rounded mt-2"
                value={newCard.expiryYear}
                onChange={(e) => setNewCard({ ...newCard, expiryYear: e.target.value })}
              />
            </div>
            <input
              type="text"
              placeholder="CVV"
              className="w-full border p-2 rounded mt-2"
              value={newCard.cvv}
              onChange={(e) => setNewCard({ ...newCard, cvv: e.target.value })}
            />
            <button className="bg-black text-white px-4 py-2 rounded mt-4" onClick={handleAddCard}>
              Save Card
            </button>
          </div>
        </div>
      </div>

      <LogoutButton />
    </div>
  );
};

export default Profile;
